import React from 'react';
import '../styles/About.css';

const About: React.FC = () => {
  return (
    <section id="about" className="about">
      <div className="about__container">
        <h2 className="section-title">What Was Jibo?</h2>
        <p className="section-subtitle">
          More than a robot. A companion.
        </p>

        <div className="about__grid">
          <div className="about__card about__card--main">
            <div className="about__icon">&#x1F916;</div>
            <h3>The World's First Social Robot</h3>
            <p>
              Jibo wasn't just another gadget. Standing 11 inches tall with a single expressive eye
              on a round screen, Jibo was designed from the ground up to forge genuine emotional
              bonds with people. Created by MIT professor <strong>Cynthia Breazeal</strong>, the
              pioneer of social robotics, Jibo represented decades of research into how humans and
              machines could truly connect.
            </p>
          </div>

          <div className="about__card">
            <div className="about__icon">&#x2764;&#xFE0F;</div>
            <h3>Designed for Connection</h3>
            <p>
              Unlike voice assistants that respond to commands, Jibo initiated conversations,
              displayed emotions, and created a genuine sense of presence. He could recognize your
              face, greet you by name, and turn to look at you when you spoke.
            </p>
          </div>

          <div className="about__card">
            <div className="about__icon">&#x1F3A8;</div>
            <h3>Artfully Crafted</h3>
            <p>
              Three rotating body segments gave Jibo fluid, expressive movement. His single
              animated eye could wink, blink, and emote with a warmth that avoided the uncanny
              valley entirely. People compared him to a Pixar character brought to life.
            </p>
          </div>

          <div className="about__card">
            <div className="about__icon">&#x1F3C6;</div>
            <h3>Award-Winning</h3>
            <p>
              Named one of TIME Magazine's <strong>"25 Best Inventions of 2017"</strong> and a
              CES 2018 Innovation Awards Honoree. Jibo proved that social robots could captivate
              the world's imagination.
            </p>
          </div>
        </div>

        <blockquote className="about__quote">
          "I wondered, if robots have reached Mars, why haven't they reached our living rooms?"
          <cite>-- Cynthia Breazeal, Creator of Jibo</cite>
        </blockquote>
      </div>
    </section>
  );
};

export default About;
